<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      />

    <!--    해당사업장-->
    <related-field-list
      class="mt-28px"
      title="해당사업장"
      :list="form.relatedFieldList"
      @updateList="updateRelatedFieldList"
      :is-print="isPrint"
      :is-readonly="board.readonly"/>

    <!-- 회의내용 -->
    <div class="mt-7">
      <h5><i class="dot"></i> 회의내용</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>회의일</div>
          <p v-if="isPrint" class="w-full flex-1">
            {{ form.inputA_1 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full"
              v-model="form.inputA_1"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div>
          <div>회의시간</div>
          <p v-if="isPrint" class="w-full flex-1">
            {{ form.inputA_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <time-selector
              class="w-full"
              v-model="form.inputA_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div>
          <div>회의장소</div>
          <p v-if="isPrint" class="print-input">{{form.inputA_3}}</p>
          <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>작업 시작시간</div>
          <div class="time">
            <time-selector v-model="form.inputA_4" :readonly="board.readonly" />
            <p>~</p>
            <time-selector v-model="form.inputA_5" :readonly="board.readonly" />
          </div>
        </div>

        <div class="writeGridLineItem">
          <div style="line-height: 25px;">작업 또는 작업장 간의 연락방법</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_6 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_6" :readonly="board.readonly" placeholder="-도급업체 대표자/사무실
-직원 휴대폰"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: 25px;">재해발생 위험 시의 대피 방법</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_7 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_7" :readonly="board.readonly" placeholder="-위기관리 대응 매뉴얼 참조
-재해발생 위험시 대피 방법
-중대재해 발생시
0. 관할 경찰서
0. 지체없이 관할 고용노동부 산재예방지도과 연락(전화, 팩스등)
※보고사항: 발생개요 및 피해상황, 조치 및 전망, 그밖의 중요사항"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: 25px;">작업장에서의 법 제41조의2제1항에 따른 위험성평가의 실시에 관한 사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_8 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_8" :readonly="board.readonly" placeholder="- 위험성평가 실시 및 조치결과 제출(00.00.00까지)"/>
        </div>
        <div class="writeGridLineItem">
          <div style="line-height: 25px;">사업주와 수급인 또는 수급인 상호 간의 연락 방법 및 작업공정의 조정</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_9 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_9" :readonly="board.readonly" placeholder="입력필드"/>
        </div>
        <div class="writeGridLineItem">
          <div>기타사항</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_10 }} </span>
          <ml-textarea v-else rows="5" v-model="form.inputA_10" :readonly="board.readonly" placeholder="입력필드"/>
        </div>
      </div>
    </div>

    <!-- 참석자 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="참석자"
      :tableData="[
        { id: 'cell1', title: '소속명', type: 'text', placeholder: '내용' },
         { id: 'cell2', title: '직책', type: 'text', placeholder: '내용' },
        { id: 'cell3', title: '성명', type: 'text', placeholder: '내용' },
        { id: 'cell4', title: '서명', type: 'sign', placeholder: '내용' },
        { id: 'cell5', title: '비고', type: 'text', placeholder: '내용' },
      ]"
      v-model="form.userTableList"
    />

    <div>
      <vs-row class="mt-12 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 확인자</h5>
        </vs-col>
      </vs-row>
      <div class="writeGridContainer">
        <div>
          <div>담당</div>
          <ml-input v-model="form.sign1.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign1.sign" :readonly="board.readonly" />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>팀장</div>
          <ml-input v-model="form.sign2.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign2.sign" :readonly="board.readonly" />
        </div>
        <div class="hidden xl:block"></div>
        <div>
          <div>과장</div>
          <ml-input v-model="form.sign3.name" :readonly="board.readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.sign3.sign" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :isPrint="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" class="mt-28px"/>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import TableInspect from "@/components/TableInspect";
import TableInspectPerformanceEvaluation from "@/components/TableInspectPerformanceEvaluation.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import SignField from "@/components/SignField.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import RelatedFieldList from "@/components/RelatedFieldList.vue";

export default {
  components: {
    RelatedFieldList,
    TableCustom,
    TimeSelector,
    SignField,
    CompanySelector,
    PhotoUploadGridModule,
    TableInspectPerformanceEvaluation,
    TableInspect,
    DateSelector,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        userTableList: [],
        relatedFieldList: [],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
        inputA_7: "",
        inputA_8: "",
        inputA_9: "",
        inputA_10: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    updateRelatedFieldList (list) {
      this.form.relatedFieldList = list;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
